import { useApplications } from "../../../../hooks/useApplications"
import { ApplicationGet } from "../../../models/Application"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { EntityTab } from "../../partials/EntityTab"

export function Applications() {
  const { applicationsList, isLoadingApplications } = useApplications(
    DimaFeatureShortNameEnum.AM
  )

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/applications",
    },
    { field: "shortName", headerName: "Short" },
  ]

  const rows = applicationsList.map((app: ApplicationGet) => ({
    id: app.id,
    name: app.name,
    shortName: app.shortName,
  }))

  return <EntityTab rows={rows} cols={columns} isLoading={isLoadingApplications} />
}
